import React, {memo, useState} from "react"

import { SendBox, Tab } from "@shared/components"
import { MessagesProvider, useChatInfo } from "@shared/contexts"

import { useMacroMessage } from "streamerChatting/hooks"

import ManagerMessages from "./ManagerMessages"
import PartnerMessages from "./PartnerMessages"
import UserMessages from "./UserMessages"

const PARTNER_MESSAGES_LIMIT_COUNT = 10000

function Chatting() {
  const { chatMenu } = useChatInfo()
  const macroMessage = useMacroMessage()

  const [showPartnerChatInput, setShowPartnerChatInput] = useState<boolean>(false)

  const isUserGroup = chatMenu === "USER"
  const isManagerGroup = chatMenu === "MANAGER"
  const isPartnerMenuSelected = chatMenu === "PARTNER"

  return (
    <>
      <Tab isUser={false} />
      <MessagesProvider>
        <UserMessages isActive={isUserGroup} />
        <ManagerMessages isActive={isManagerGroup} />
        {(isUserGroup || isManagerGroup) && (
          <SendBox isUser={false} macroMessage={macroMessage} />
        )}
      </MessagesProvider>
      <MessagesProvider
        firebaseRef="partner_messages"
        limitCount={PARTNER_MESSAGES_LIMIT_COUNT}
      >
        <PartnerMessages isActive={isPartnerMenuSelected} />
        {(showPartnerChatInput && isPartnerMenuSelected) && (
          <SendBox isUser={false} macroMessage={macroMessage} />
        )}
      </MessagesProvider>
    </>
  )
}

export default memo(Chatting)
